<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const handleNextStep = async () => {
  await handleNext('tutorial_resources_overview')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/resources.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.resources.overview.lotGoingOn') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.resources.overview.flowFromTop') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.resources.overview.level1Ores') }}
      </p>
      <p class="pb-2">
        <i18n-t keypath="tutorial.resources.overview.buildHarvesters" tag="span">
          <template #oreIcon><GenericIcon type="ore"/></template>
          <template #storageIcon><GenericIcon type="ore_storage"/></template>
        </i18n-t>
      </p>
    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton @click="handleNextStep">
        {{ t('tutorial.resources.overview.gotIt') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>